export { HOME_BRAND as OPENGRADIENT_BRAND } from 'ui/home/brand';
